var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "text-white header" }, [_vm._t("header")], 2),
    _vm._v(" "),
    _vm.editMode
      ? _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("b-input", {
              staticClass: "input-header",
              attrs: {
                type: "number",
                placeholder: "Часы",
                size: "sm",
                min: "0"
              },
              model: {
                value: _vm.newHours,
                callback: function($$v) {
                  _vm.newHours = _vm._n($$v)
                },
                expression: "newHours"
              }
            }),
            _vm._v(" "),
            _c("b-input", {
              staticClass: "input-header",
              attrs: {
                type: "number",
                placeholder: "Минуты",
                size: "sm",
                min: "0"
              },
              model: {
                value: _vm.newMinutes,
                callback: function($$v) {
                  _vm.newMinutes = _vm._n($$v)
                },
                expression: "newMinutes"
              }
            }),
            _vm._v(" "),
            _c("el-button", {
              staticClass: "no-outline ml-1 micro-button",
              attrs: {
                icon: "el-icon-check",
                type: "success",
                size: "mini",
                circle: ""
              },
              on: {
                click: function($event) {
                  return _vm.saveChanges()
                }
              }
            }),
            _vm._v(" "),
            _c("el-button", {
              staticClass: "no-outline ml-1 micro-button",
              attrs: {
                icon: "el-icon-close",
                type: "danger",
                size: "mini",
                circle: ""
              },
              on: {
                click: function($event) {
                  return _vm.cancelEdit()
                }
              }
            })
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("span", { staticClass: "timing" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.hours) +
                  " ч.\n      " +
                  _vm._s(_vm.minutes) +
                  " м.\n    "
              )
            ]),
            _vm._v(" "),
            _c("el-button", {
              staticClass: "no-outline ml-2 micro-button",
              attrs: {
                icon: "el-icon-edit",
                type: "primary",
                size: "mini",
                circle: ""
              },
              on: {
                click: function($event) {
                  return _vm.startEdit()
                }
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7aecbbf5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aecbbf5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeDeliveryForm.vue
// module id = null
// module chunks = 